/**
 * plural — contagem + substantivo flexionado.
 *
 * ─── POR QUE ISTO EXISTE ────────────────────────────────────────────────────
 *
 * "1 ordens" e "1 contratos" foram defeitos REAIS, vistos em device (CLAUDE.md
 * #87). Nenhum teste pegou porque todos os fixtures tinham **2 de tudo** — a
 * contagem 1 é exatamente o caso que o autor do fixture não escreve. Escrever
 * `${n} orçamentos` na string é o modo de falha; este helper é o antídoto.
 *
 * Regra do repo: **todo texto com contagem passa por aqui**, e todo teste de
 * texto com contagem inclui um caso com 1.
 */

/** `1 → "1 ordem"`, `3 → "3 ordens"`. */
export function plural(n: number, singular: string, pluralForm: string): string {
  return `${n} ${n === 1 ? singular : pluralForm}`;
}

/**
 * Só o substantivo, sem o número — para quando a contagem já aparece em outro
 * nó (ex.: um número grande em destaque com o rótulo abaixo).
 */
export function pluralWord(n: number, singular: string, pluralForm: string): string {
  return n === 1 ? singular : pluralForm;
}
